import React from 'react'

export default () => {
  return (
    <div className='element-corner--triangle -position-left -color-trending'>
      <div>
        <i className='e-icon -icon-bolt' />
        <span className='e-icon__alt'>Trending</span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/components/itemCard/common/trendingItem.js